import { defineMessages } from 'react-intl';

export const messages: {
	conversationNotFoundTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	conversationNotFoundDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	conversationNotFoundTitle: {
		id: 'ai-mate.chat-error-banner.title',
		defaultMessage: 'Start new chat',
		description: 'Error message title for when converation is not found',
	},
	conversationNotFoundDescription: {
		id: 'ai-mate.chat-error-banner.description',
		defaultMessage: 'Your chat history is saved up to 30 days.',
		description: 'Error message description for when converation is not found',
	},
});
